<template>
  <div class="row gap-4">
    <div
      v-if="showGrouping"
      class="d-flex custom-button clickable"
      @click="handleGroupToggle"
    >
      <BFormCheckbox
        v-model="groupByOrgLocal"
        switch
      />
      Pogrupuj po organizacji
    </div>
    <div
      v-if="false && showGrouping && hasGroups"
      class="d-flex custom-button"
    >
      <Tippy
        ref="groupPopover"
        trigger="click"
        interactive
        theme="light"
        placement="bottom"
        @show="onGroupDropdownShow"
      >
        <template #trigger>
          <div class="group-filter-trigger">
            <i class="fas fa-layer-group pr-2" />
            {{ selectedGroupName }}
            <i
              v-if="selectedGroupFilterLocal.length > 0"
              class="fas fa-times pl-2 clear-icon"
              @click.stop="clearGroupFilter"
            />
          </div>
        </template>
        <div style="padding-bottom: 5.5px">
          <SearchBox
            ref="search"
            v-model="search"
            :height="30"
            constant-width
          />
        </div>
        <div class="dropdown-scroll">
          <GroupMultiSelect
            :groups="filteredGroupOptions"
            :selected="selectedGroupFilterLocal"
            :root-id="'#all'"
            :expand="!!search"
            @toggle="toggleGroup"
            @toggle-batch="toggleGroupBatch"
          />
        </div>
      </Tippy>
    </div>
    <div
      v-if="showGrouping"
      class="d-flex custom-button clickable rounded-pill"
      @click="$emit('collapse-all')"
    >
      <i class="fas fa-arrows-to-line pr-2" />
      Zwiń wszystko
    </div>
    <div
      v-if="showGrouping"
      class="d-flex custom-button clickable rounded-pill"
      @click="$emit('expand-all')"
    >
      <i class="fas fa-arrows-from-line pr-2" />
      Rozwiń wszystko
    </div>
  </div>
</template>

<script>
import createSearch from '@/utils/search';
import GroupMultiSelect from './GroupMultiSelect';

export default {
  props: {
    showGrouping: {
      type: Boolean,
      default: false,
    },
    groupByOrg: {
      type: Boolean,
      default: false,
    },
    selectedGroupFilter: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: '',
  }),
  components: {
    GroupMultiSelect,
  },
  computed: {
    groupByOrgLocal: {
      get() {
        return this.groupByOrg;
      },
      set(value) {
        this.$emit('update:groupByOrg', value);
      },
    },
    selectedGroupFilterLocal: {
      get() {
        return this.selectedGroupFilter;
      },
      set(value) {
        this.$emit('update:selectedGroupFilter', value);
      },
    },
    hasGroups() {
      return this.groups && this.groups.length > 0;
    },
    selectedGroupName() {
      if (!this.selectedGroupFilterLocal || this.selectedGroupFilterLocal.length === 0) {
        return 'Wszystkie grupy';
      }
      if (this.selectedGroupFilterLocal.length === 1) {
        const group = this.groupOptions.find((x) => x.key === this.selectedGroupFilterLocal[0]);
        return group?.text || 'Wszystkie grupy';
      }
      return `Wybrano grup: ${this.selectedGroupFilterLocal.length}`;
    },
    filteredGroupOptions() {
      const nonAllGroups = this.groupOptions.filter((g) => g.code !== '#all');

      if (!this.search) {
        return nonAllGroups;
      }

      const search = createSearch(this.search);
      const filteredGroups = nonAllGroups.filter((x) => search(x.path));

      const foundCodes = filteredGroups.flatMap((x) => this.getParents(x.code));

      return nonAllGroups.filter((g) => foundCodes.includes(g.code));
    },
    groupOptions() {
      return (this.groups || []).map((x) => ({
        key: x.code,
        code: x.code,
        text: x.code === '#all' ? 'Wszystkie grupy' : x.name,
        path: x.code === '#all' ? 'Wszystkie grupy' : x.path,
        size: x.size,
        parentCode: x.parentCode,
      }));
    },
  },
  methods: {
    handleGroupToggle(e) {
      if (!e.target.closest('label')) {
        this.groupByOrgLocal = !this.groupByOrgLocal;
      }
    },
    getParents(code) {
      if (!code || code === '#all') {
        return [];
      }

      const group = this.groupOptions.find((x) => x.code === code);
      return [code, ...this.getParents(group.parentCode)];
    },
    toggleGroup(code) {
      const current = [...this.selectedGroupFilterLocal];
      const index = current.indexOf(code);

      if (index > -1) {
        current.splice(index, 1);
      } else {
        current.push(code);
      }

      this.selectedGroupFilterLocal = current;
    },
    toggleGroupBatch(codes, shouldSelect) {
      const current = [...this.selectedGroupFilterLocal];

      codes.forEach((code) => {
        const index = current.indexOf(code);

        if (shouldSelect && index === -1) {
          current.push(code);
        } else if (!shouldSelect && index > -1) {
          current.splice(index, 1);
        }
      });

      this.selectedGroupFilterLocal = current;
    },
    clearGroupFilter() {
      this.selectedGroupFilterLocal = [];
    },
    onGroupDropdownShow() {
      this.$nextTick(() => {
        if (this.$refs.search) {
          this.$refs.search.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-button {
  background-color: #eee;
  padding: 5px 10px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  min-width: 200px;
}
.rounded-button {
  border-radius: 100%;
}

.gap-4 {
  gap: 12px;
}

.clickable {
  cursor: pointer;
}

.group-filter-trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
}

.clear-icon {
  opacity: 0.6;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.dropdown-scroll {
  max-height: 400px;
  overflow-y: auto;
  min-width: 250px;
}
</style>
